// src/components/Authentication/GoogleAuthButton.jsx
import React, {useContext} from 'react';
import {useGoogleSignIn} from '../../hooks/useGoogleSignIn';
import {useNavigate} from 'react-router-dom';
import './GoogleAuthButton.css';
import {AuthContext} from "../../context/AuthContext"; // Optional styles
import googleIcon from '../../assets/google.svg';

const GoogleAuthButton = ({className = '', onSuccess, onError, children = '', affiliateCode = null, newsletter = false}) => {
  const {signIn: googleSignIn} = useGoogleSignIn();
  const {setToken} = useContext(AuthContext); // Adapt to your context
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  // const [error, setError] = React.useState(null);

  const handleGoogleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);
    try {
      const data = await googleSignIn({
        affiliate: affiliateCode,
        newsletter
      });
      setToken(data.access_token);
      localStorage.setItem('token', data.access_token);
      if (onSuccess) onSuccess(data);
      navigate('/shop');
    } catch (err) {
      console.error('Google login error:', err);
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={`google-auth-btn ${className} ${loading ? 'loading' : ''}`}
      onClick={handleGoogleLogin}
      disabled={loading}
      aria-label=""
    >
      <>
        <img
          src={googleIcon}
          width="20"
          height="20"
          alt="Google Login"
          aria-hidden="true"
        />
        {children}
      </>
      {/*{error && <span className="error">{error}</span>}*/}
    </button>
  );
};

export default GoogleAuthButton;
